import { render, staticRenderFns } from "./GetWindow.vue?vue&type=template&id=7a10846c&scoped=true&"
import script from "./GetWindow.vue?vue&type=script&lang=js&"
export * from "./GetWindow.vue?vue&type=script&lang=js&"
import style0 from "./GetWindow.vue?vue&type=style&index=0&id=7a10846c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10846c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
